import { AUDIT_GET_FAILURE, AUDIT_GET_SUCCESS, AUDIT_GETTING,
    AUDIT_RESET 
} from "./actions"



const initialState = {
    audit: {
        "data": null,
        "error": null,
        loading: true
    }
}

export const auditReducer = (state = initialState, action) => {
    let payload = action.payload

    switch (action.type) {
        case AUDIT_GETTING:
            return {
                ...state,
                loading: true,
                data: payload,
                error: null
            }
        case AUDIT_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                data: payload,
                error: null
            }
        case AUDIT_GET_FAILURE:
            return {
                ...state,
                loading: false,
                data: null,
                error: payload
            }

        case AUDIT_RESET:
            return {
                ...state,
                loading: false,
                data: null,
                error: null
            }
        
        default:
            return state
    }
}